/*
 * @Descripttion:
 * @Date: 2024-08-06 10:12:42
 */
import http from '@/utils/http/axios';
import type { InformationList, ZonesList } from './types';
import { ContentTypeEnum } from '@/utils/http/axios/enums';

enum Api {
  informationList = '/front-end/info/api/v1/information', // 资讯列表
  addOrUpdate = '/front-end/info/api/v1/addOrUpdate', // 新增编辑资讯
  infoDetail = '/front-end/info/api/v1/detail', // 资讯详情查看

  zonesList = '/front-end/info/api/v1/zones', // 关联专区列表
  delInfo = '/front-end/info/api/v1/delInfo' // 资讯删除
}

export const informationList: InformationList = params =>
  http.request({
    url: Api.informationList,
    method: 'POST',
    params
  });
export const addOrUpdate = async (params: {
  id?: number; // 更新时资讯id必传
  title: string; // 资讯标题
  author: string; // 资讯作者
  content: string; // 资讯内容
  cover: string; // 资讯封面
  contentType: number; // 是否上传视频1否2是
  videoUrl?: string; // 视频地址
  videoCover?: string; // 视频封面
  hasForm?: number; // 是否关联表单 0 否  1是
}): Promise<Result<{}>> =>
  http.request({
    url: Api.addOrUpdate,
    method: 'POST',
    params
  });

export const infoDetail = async (params: {
  id?: number;
  hasForm?: number; // 是否关联表单 0 否  1是
}): Promise<
  Result<{
    id: number;
    infoCode: string; //资讯编号
    title: string; //资讯标题
    author: string; //资讯作者
    content: string; //资讯内容
    cover: string; //资讯封面
    videoUrl: string; //上传视频地址
    videoLink: string; //输入视频地址
    videoCover: string; //视频封面
    contentType: number; //1资讯2视频
    updatable: number; //是否允许更新0否1是
    deleted: number; //是否删除0否1是
    createAt: string; //创建时间
    updateAt: string; //更新时间
  }>
> =>
  http.request({
    url: Api.infoDetail,
    method: 'GET',
    params
  });

export const zonesList: ZonesList = params =>
  http.request({
    url: Api.zonesList,
    method: 'POST',
    params
  });

export const delInfo = async (params: { id?: number; hasForm: number }) =>
  http.request(
    {
      url: Api.delInfo,
      method: 'POST',
      params
    },
    {
      isParseToJson: false,
      headers: { 'content-type': ContentTypeEnum['FORM_URLENCODED'] }
    }
  );
